export const error_code_map = {
  '1001':'TCaptcha.js 加载错误',
  '1002':'调用 show 方法超时',
  '1003':'中间 js 加载超时',
  '1004':'中间 js 加载错误',
  '1005':'中间 js 运行错误',
  '1006':'拉取验证码配置错误/超时',
  '1007':'iframe 加载超时',
  '1008':'iframe 加载错误',
  '1009':'jquery 加载错误',
  '1010':'滑块 js 加载错误',
  '1011':'滑块 js 运行错误',
  '1012':'刷新连续错误3次',
  '1013':'验证网络连续错误3次'
}



// WEBPACK FOOTER //
// ./src/components/login-form/captcha_error_code.js